import type { Fields, ValidateOptions, Validator } from '@burnsred/entity';

/*
FIXME Type '(value: Map<string, string>, options: ValidateOptions) => ValidatorResult' is not assignable to type 'Validator'.
  Types of parameters 'value' and 'value' are incompatible.
    Type 'unknown' is not assignable to type 'Map<string, string>'
*/
/** A helper that skips a validator when entity is new (no uuid) */
export const onlyWhenPersisted =
  (validator: Validator) =>
  (value: Map<string, string>, options: ValidateOptions) => {
    if (!options.record?.get('uuid')) return false;
    return validator(value, options);
  };

const isRequiredValidatorName = 'isRequired' as const;

/**
 * Returns true if the entity field definition includes the isRequired
 * validator, which is injected if `blank: false` is set.
 */
export const isFieldRequired = (field: unknown) =>
  (field as InstanceType<typeof Fields.Field>)?.validators?.some(
    (v: { name: string }) => v.name === isRequiredValidatorName,
  );
